var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesktopOval1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1899,
    height: 1686,
    viewBox: "0 0 1899 1686",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f_254_561)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1473.49 331.687C1574.08 454.959 1739.36 1019.95 1435.97 1267.51C1132.58 1515.06 475.41 1351.44 374.824 1228.17C274.237 1104.9 205.723 881.317 509.112 633.761C794.789 365.383 1372.91 208.415 1473.49 331.687Z",
    fill: "url(#paint0_linear_254_561)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_254_561",
    x: 0.44873,
    y: 0.0153809,
    width: 1898.33,
    height: 1685.36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 144.5,
    result: "effect1_foregroundBlur_254_561"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_254_561",
    x1: 445.664,
    y1: 1314.99,
    x2: 1544.33,
    y2: 418.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#616569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552788,
    stopColor: "#616569",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#616569"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopOval1);
export default __webpack_public_path__ + "static/media/desktop-oval-1.1f10c70f8806e8a4f44b4567367a6c41.svg";
export { ForwardRef as ReactComponent };